import { useTeam } from '@vrplatform/data';
import { LedgerReservationDetailDrawer } from './LedgerReservationDetailDrawer';
import { LegacyReservationDetailDrawer } from './LegacyReservationDetailDrawer';

export const ReservationDetailDrawer = () => {
  const [{ isGL }] = useTeam();

  if (isGL) return <LedgerReservationDetailDrawer />;

  return <LegacyReservationDetailDrawer />;
};
